var scaleCorrectors = {};
function addScaleCorrector(correctors) {
    Object.assign(scaleCorrectors, correctors);
}

export { addScaleCorrector, scaleCorrectors };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/projection/styles/scale-correction.mjs
// module id = TsQ6
// module chunks = 0